import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedFirestopList } from '../selectors/firestop-documentation.selectors';
import { patchUpdateFirestopListAsDeleted } from '../services/patch-update-firestop-list-as-deleted.service';

export const deleteFirestopList = createAsyncThunk(
  'firestopDocumentation/deleteFirestopList',
  async (_, { getState }) => {
    const selectedFirestopList = selectSelectedFirestopList(getState());
    const deletedFirestopListData = await patchUpdateFirestopListAsDeleted(
      selectedFirestopList.projectId,
      selectedFirestopList.id
    );
    return deletedFirestopListData;
  }
);
